import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.semantic.border.default};
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.semantic.action.primary};
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
`;

export const Code = styled.pre`
  margin: 0;
  padding: 12px;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre;
  overflow-x: auto;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
`;
